<template>
  <transition name="modal-fade">
    <div class="announcement-overlay" v-if="visible" @click.self="close">
      <div class="announcement-card">
        <button class="close-btn" @click="close">&times;</button>
        <div class="announcement-title">{{ announcement.title }}</div>
        <div class="announcement-content" v-html="announcement.content"></div>
        <div class="announcement-actions">
          <button class="dismiss-btn" @click="dismissToday">今日不再显示</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { apiFetch } from '@/config/api'

export default {
  name: 'AnnouncementPopup',
  data() {
    return {
      visible: false,
      announcement: {
        id: null,
        title: '',
        content: ''
      }
    }
  },
  mounted() {
    this.fetchAnnouncement()
  },
  methods: {
    async fetchAnnouncement() {
      try {
        const res = await apiFetch('/api/announcement/active')
        if (res && res.code === 0 && res.data) {
          this.announcement = res.data
          // 检查今天是否已关闭
          const key = 'announcement_dismissed_' + res.data.id
          const dismissed = localStorage.getItem(key)
          const today = new Date().toISOString().slice(0, 10)
          if (dismissed !== today) {
            this.visible = true
          }
        }
      } catch (e) {
        // 静默处理
      }
    },
    close() {
      this.visible = false
    },
    dismissToday() {
      if (this.announcement.id) {
        const key = 'announcement_dismissed_' + this.announcement.id
        const today = new Date().toISOString().slice(0, 10)
        localStorage.setItem(key, today)
      }
      this.visible = false
    }
  }
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.announcement-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.announcement-card {
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px 20px;
  max-width: 360px;
  width: 100%;
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 22px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 4px;
}

.close-btn:hover {
  color: #333;
}

.announcement-title {
  font-size: 17px;
  font-weight: 600;
  color: #111;
  margin-bottom: 14px;
  padding-right: 24px;
}

.announcement-content {
  font-size: 14px;
  color: #444;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 20px;
}

.announcement-content::-webkit-scrollbar {
  width: 4px;
}

.announcement-content::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 2px;
}

.announcement-content :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 8px 0;
}

.announcement-actions {
  text-align: center;
}

.dismiss-btn {
  background: #111;
  color: #fff;
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  transition: opacity 0.15s;
}

.dismiss-btn:hover {
  opacity: 0.85;
}
</style>
